module.exports = {
  "checkbox": {
    "width": "48",
    "height": "48"
  },
  "title-text": {
    "fontSize": "30"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-0cca5dd5!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/wxc-checkbox/index.vue
// module id = 161
// module chunks = 0 1